<template>
  <div></div>
  <!--<div class="sidebar-header"></div>-->
</template>
<script>

export default {
  name: 'sidebar-header'
}
</script>



// WEBPACK FOOTER //
// SidebarHeader.vue?8499a56a